// RequireAdmin.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../hooks/useAdminAuth";
import routePaths from "../../routes/routePaths";

export default function RequireAdmin({ children }) {
  const { checking, isAdmin } = useAdminAuth();
  const location = useLocation(); // 👈 thêm dòng này

  if (checking) return <div>Đang kiểm tra quyền truy cập...</div>;

  if (!isAdmin) {
    return (
      <Navigate
        to={routePaths.login}
        replace
        state={{ from: location }} // 👈 truyền thông tin nơi bị redirect
      />
    );
  }

  return children;
}
